module.exports = __webpack_public_path__ + "img/ae-logo.3dad4907.svg";